import * as Yup from 'yup';

import createAccountModel from '../models/createAccountModel';

const {
  formField: { createAccountName, createAccountEmail, createAccountPass },
} = createAccountModel;

const createAccountSchema = {
  [createAccountName.name]: Yup.string()
    .required(`${createAccountName.requiredErrorMsg}`)
    .test(
      'not-an-email',
      'Name must not be an email address',
      (value: string | undefined) => {
        if (!value) return true; // required validator handles empty
        // Basic email pattern check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return !emailRegex.test(value);
      }
    )
    .test(
      'not-a-phone',
      'Name must not be a phone number',
      (value: string | undefined) => {
        if (!value) return true; // required validator handles empty
        // Phone number pattern check (matches various formats including spaced numbers like 01234 567 890)
        const phoneRegex =
          /^[+]?[(]?[0-9]{1,5}[)]?[-\s.]?[0-9]{2,5}[-\s.]?[0-9]{2,6}([-\s.]?[0-9]{1,5})*$/;
        return !phoneRegex.test(value);
      }
    ),

  [createAccountEmail.name]: Yup.string()
    .required(`${createAccountEmail.requiredErrorMsg}`)
    .email(`${createAccountEmail.invalidErrorMsg}`),

  [createAccountPass.name]: Yup.string()
    .required(`${createAccountPass.requiredErrorMsg}`)
    .min(8, `${createAccountPass.invalidErrorMsg}`),
};

export default createAccountSchema;
